<div [formGroup]="parentFormGroup">
	<quill-editor placeholder="{{ 'wysiwyg.enterText' | lokalizace }}"
				  [formControlName]="nazevPrvkuFormulare"
				  [readOnly]="readonly"
				  [modules]="readonly ? readonlyKonfigurace : defaultniKonfigurace"
				  [styles]="editorStyly"
				  (onEditorCreated)="nastavitVlastniNastaveniEditoru($event)"></quill-editor>
</div>
